import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { consumeViewHandoff } from './boot/view-handoff';
import { App } from './App';
import { builderLocale } from './i18n';
import { loadBuilderDictionary } from './i18n/locales';
import './styles/global.css';
// The canvas previews the storefront, so it must also load the storefront THEME stylesheet (the
// aqx-theme / aqx-scheme tokens + the [data-aqx-page] query-container rule). Imported as its OWN sheet
// (not @import-chained into global.css) so theme.css's leading font @import stays valid.
import '@aquilixshop/tokens/theme';

// BEFORE render: a superadmin consultation seeds its read-only token from the URL fragment, so
// BuilderBoot never asks the refresh cookie (the old cookie path is why consultation was blocked).
consumeViewHandoff();

// The document's language is the SELLER's reading language (0051 lot 4): `index.html` ships `lang="en"`
// because the floor is English, and a French or Arabic inspector under an English `lang` misleads screen
// readers and spell-checkers alike. The canvas keeps the SHOP's `lang` on its own subtree.
document.documentElement.lang = builderLocale();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Builder root element #root not found in index.html');
}

// The seller's dictionary is a CHUNK (one per language), fetched before the first render rather than
// bundled into the entry: six eager dictionaries put ~1.4 MB of source in the cold-load path so that
// one of them could be read. Awaiting it here keeps the guarantee the eager imports gave — the first
// paint is already in the seller's language, no label flips from English a moment later — and the
// promise never rejects, so a chunk that fails to arrive opens the editor on its English floor
// instead of a blank page. `?ui=` is already resolved at module scope, so this asks for one file.
void loadBuilderDictionary().then(() => {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
